import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e1a90e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "uu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.got), 1),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        placeholder: "email"
      }, null, 512), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("p", null, "Введенный email: " + _toDisplayString(_ctx.email), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        placeholder: "password"
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _createElementVNode("p", null, "Введенный пароль: " + _toDisplayString(_ctx.password), 1),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args)))
      }, "Зарегаться"),
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearUsers && _ctx.clearUsers(...args)))
      }, "Очистить"),
      _hoisted_6,
      _createElementVNode("label", null, _toDisplayString(_ctx.status), 1)
    ])
  ]))
}